// import React, {useEffect, useState} from "react";
// import {
//     Form,
//     notification,
//     InputBox,
//     Card
// } from "../../components/Elements/appUtils";
// import {FetchCatgory} from "../variants/actions";
// import {Boolean} from "../../components/_utils/_utils";
// import PageHeader from "../../components/Elements/pageHeader";
// import {useDispatch} from "react-redux";
// import {FetchVariants} from "../variants/actions";
// import {GetEachFormFields} from "../../components/_utils/formUtils";
// import _ from "lodash";
// import {singleProductFxn, updateProductFxn} from "./actions";
// import {category} from "../../components/_utils/appUtils";
// import {vegNonVeg} from "../../components/_utils/_utils";
// import {getToken} from "../../request";

// const EditProduct = (props) => {
//     const [formData, setFormData] = useState([
//         {variantId: "", price: "", name: ""},
//     ]);
//     console.log(formData,"formdata")
//     const [allCategory, setAllCategory] = useState([])
//     const [productFile, setproductFile] = useState("");
//     const [showDeleteButtons, setShowDeleteButtons] = useState([false]);
//     const [variant, setVariant] = useState([]);
//     const [mainCategoryIndex, setMainCategoryIndex] = useState("");
//     const [categoryIndex, setCategoryIndex] = useState("");
//     const [oldSubCategory, setOldSubCategory] = useState([]);
//     const {getFieldValue, setFieldsValue} = props.form;
//     let dispatch = useDispatch();
//     const [productId, setproductId] = useState("");
//     useEffect(() => {
//         checkproductId();
//         getVariant();
//     }, []);

//     const getVariant = async(params) => {
//         try {
//             const {data} = await FetchVariants({
//                 category: getFieldValue("categoryId"),
//                 results:100,
//                 count:100
//             });
//             setVariant(data.data);
//         } catch (error) {
//             console.error("Error fetching data:", error);
//         }
//     };

//     let id;

//     const handleInputChange = (index, field, value) => {
//         const newData = [...formData];
//         newData[index][field] = value;
//         setFormData(newData);
//         setShowDeleteButtons((prevButtons) =>
//             prevButtons?.map((btn, idx) => (idx === index ? true : btn))
//         );
//     };

//     const handleDelete = (index) => {
//         const newPayments = [...formData];
//         newPayments.splice(index, 1);
//         setFormData(newPayments);
//         setShowDeleteButtons((prevButtons) =>
//             prevButtons?.filter((_, idx) => idx !== index)
//         );
//     };

//     const handleAddField = () => {
//         let lastData = {};
//         if (formData && formData.length) {
//             lastData = formData[formData.length - 1];
//             if (!lastData.variantId) {
//                 notification.warning({message: "Please Choose Variant"});
//                 return;
//             }
//             if (!lastData.price) {
//                 notification.warning({message: "Please Enter Price"});
//                 return;
//             }
//         }

//         setFormData([...formData, {variantId: "", price: "", name: ""}]);

//         setShowDeleteButtons([...showDeleteButtons, true]);
//     };
//     const handleFileChange = (e) => {
//         const file = e.files[0];
//         setproductFile(file);
//     };

//     const checkproductId = async () => {
//         let searchParams = new URLSearchParams(window.location.search);
//         id = searchParams.get("_id");
//         if (id) {
//             getSingleproduct(id);
//             setproductId(id);
//         }
//     };
//     const getSingleproduct = async (id) => {
//         let {data, success} = await dispatch(singleProductFxn(id), getToken());
//         if (success) {
//             setTimeout(() => {
//                 props.form.setFieldsValue({
//                     name: data.name,
//                     menu: data.menu,
//                     code: data.code,
//                     price: data.price,
//                     categoryId: data.categoryId,
//                     gst: data.gst,
//                     vegNonVeg: data.vegNonVeg,
//                     coupon: data.coupon
//                 })
//                 setFormData(data.variants)
//             }, 300);

//         }
//     };
//     useEffect(() => {
//         handleState();

//     }, []);

//     const handleState = async () => {
//         let x = await FetchCatgory({results: 500});
//         setAllCategory(x.data)
//         setOldSubCategory(x.data)
//     };

//     const handleSubmit = (e) => {
//         const {form} = props;
//         e.preventDefault();

//         form.validateFields(async (err, valData) => {
//             if (!err) {
//                 valData._id = productId
//                 valData.variants = formData;
//                 valData.mainCategoryIndex = mainCategoryIndex;
//                 valData.categoryIndex = categoryIndex;
//                 let fd = new FormData();
//                 fd.append("obj", JSON.stringify(valData));
//                 if (productFile && productFile.name) {
//                     fd.append("productFile", productFile);
//                 }

//                 let x = await dispatch(updateProductFxn(fd));
//                 if (x && x.success) {
//                     // navigate('/productList')
//                     window.history.back();
//                 }
//             } else {
//                 if (err.name) {
//                     notification.warning({
//                         message: `Please enter Name`,
//                     });
//                     return;
//                 }

//                 notification.warning({
//                     message: "Fill All Required Fields",
//                 });
//             }
//         });
//     };

//     useEffect(() => {

//         let subcategory = allCategory.filter((item) => {

//             return item.menu == getFieldValue("menu");
//         });
//         if (subcategory) {
//             setAllCategory(subcategory);
//         }
//     }, [getFieldValue("menu")]);

//     let inputTypes = {
//         fields: [
//             {
//                 key: "name",
//                 label: "Name *",
//                 span: "col-md-4",
//             },
//             {
//                 key: "menu",
//                 label: "Main Category",
//                 span: "col-md-4",
//                 type: "select",
//                 options: category,
//                 keyAccessor: (x) => x.name,
//                 valueAccessor: (x) => `${x.name}`,
//                 onChange: (selectedOption) => {
//                     const [key, index] = selectedOption.split("_");
//                     let findIndex = _.find(category, (item) => {
//                         return item.name == selectedOption;
//                     });
//                     setMainCategoryIndex(findIndex.index);
//                     props.form.setFieldsValue({
//                         menu: key,
//                         mainCategoryIndex: findIndex.index,
//                         categoryId: ""
//                     });
//                     setAllCategory(oldSubCategory)
//                 },
//             },
//             {
//                 key: "categoryId",
//                 label: "Select Category *",
//                 span: "col-md-4",
//                 // placeholder: "Categories",
//                 type: "select",
//                 options: allCategory,
//                 showSearch: true,
//                 keyAccessor: (x) => x._id,
//                 valueAccessor: (x) => `${x.name}`,

//                 onChange: (selectedOption) => {
//                     const [key, index] = selectedOption.split("_");
//                     let findIndex = _.find(allCategory, (item) => {
//                         return item._id == selectedOption;
//                     });

//                     setMainCategoryIndex(findIndex.mainCategoryIndex);
//                     setCategoryIndex(findIndex.index);

//                     props.form.setFieldsValue({
//                         categoryId: key,
//                         mainCategoryIndex: findIndex.mainCategoryIndex,

//                     });
//                 },
//             },
//             {
//                 key: "code",
//                 label: "Code *",
//                 span: "col-md-4",
//                 // placeholder: "Product Code",
//             },
//             {
//                 key: "price",
//                 label: "Price *",
//                 type: "number",
//                 span: "col-md-4",
//                 // placeholder: "Price",
//                 hidden: getFieldValue("type") === "Product",
//             },
//             {
//                 key: "gst",
//                 label: "GST*",
//                 span: "col-md-4",
//                 // placeholder: "GST Rate",
//                 type: "select",
//                 options: Boolean,
//                 showSearch: true,
//                 keyAccessor: (x) => x.value,
//                 valueAccessor: (x) => `${x.name}`,
//                 onChange: (x) => {
//                     props.form.setFieldsValue({
//                         gst: x,
//                     });
//                 },
//                 // required: true,
//             },
//             {
//                 key: "coupon",
//                 label: "Apply-Discount/Coupon*",
//                 span: "col-md-4",
//                 // placeholder: "GST Rate",
//                 type: "select",
//                 options: Boolean,
//                 showSearch: true,
//                 keyAccessor: (x) => x.value,
//                 valueAccessor: (x) => `${x.name}`,
//                 onChange: (x) => {
//                     props.form.setFieldsValue({
//                         coupon: x,
//                     });
//                 },
//                 // required: true,
//             },
//             {
//                 key: "vegNonVeg",
//                 label: "Veg/Non-Veg/Egg*",
//                 span: "col-md-4",
//                 type: "select",
//                 options: vegNonVeg,
//                 showSearch: true,
//                 keyAccessor: (x) => x.name,
//                 valueAccessor: (x) => `${x.name}`,
//                 onChange: (x) => {
//                     props.form.setFieldsValue({
//                         vegNonVeg: x,
//                     });
//                 },
//                 // required: true,
//             },

//             {
//                 key: "productFile",
//                 label: "Product File",
//                 required: false,
//                 type: "file",
//                 fileName: productFile,
//                 onChange: ({target}) => {
//                     handleFileChange(target);
//                 },
//                 span: "col-md-4",
//             },
//         ],
//     };

//     return (
//         <>
//             <PageHeader title={"Edit Product"}>
//                 <div className="card">
//                     <div className="card-body">
//                         <Form onSubmit={handleSubmit}>
//                             <div className="form-elements-wrapper">
//                                 <div className={"row"}>
//                                     {inputTypes.fields.map((item, key) => {
//                                         return !item.hidden ? (
//                                             <div
//                                                 className={`${item.span ? item.span : "col-md-6"}`}
//                                                 key={key}
//                                             >
//                                                 <GetEachFormFields {...props.form} item={item}/>
//                                             </div>
//                                         ) : null;
//                                     })}
//                                 </div>
//                             </div>
//                             <Card title={"Variants"} size={"small"}>
//                                 <div>
//                                     <div>
//                                         {formData?.map((data, index) => (
//                                             <div key={index} className={"row"}>
//                                                 <div className={"col-md-3"}>
//                                                     <InputBox title={"Variants"}>
//                                                         <select
//                                                             className="form-control"
//                                                             value={data.variantId}
//                                                             onChange={(e) => {
//                                                                 e = JSON.parse(e.target.value);
//                                                                 handleInputChange(index, "variantId", e._id);
//                                                                 handleInputChange(index, "name", e.name);
//                                                             }}
//                                                             required="true"
//                                                         >
//                                                             <option value="">
//                                                                 {data.variantId
//                                                                     ? ` ${data.name}`
//                                                                     : "Select Variant"}
//                                                             </option>
//                                                             {variant?.map((item) => (
//                                                                 <option key={item._id} value={JSON.stringify(item)}>
//                                                                     {item.name}
//                                                                 </option>
//                                                             ))}
//                                                         </select>
//                                                     </InputBox>
//                                                 </div>
//                                                 <div className={"col-md-3"}>
//                                                     <InputBox title={"Price"}>
//                                                         <input
//                                                             className={"form-control"}
//                                                             type="number"
//                                                             value={data.price}
//                                                             onChange={(e) =>
//                                                                 handleInputChange(index, "price", e.target.value)
//                                                             }
//                                                             placeholder="Amount"
//                                                         />
//                                                     </InputBox>
//                                                 </div>
//                                                 <div className={"col-md-3"}>
//                                                     <InputBox className="deleteBtn">
//                                                        {/* <div key={index} className={"item-flex margin-variant"}>
//                                                             {index > 0 &&
//                                                             showDeleteButtons[index] && ( // Condition added to not show delete button for zero index
//                                                                 <a
//                                                                     className="empty_btn"
//                                                                     onClick={() => handleDelete(index)}
//                                                                 >
//                                                                     <i className="fa fa-trash-alt"/>
//                                                                 </a>
//                                                             )}
//                                                         </div>*/}
//                                                         <div key={index} className={"item-flex margin-variant"}>
//                                                                 <a
//                                                                     className="empty_btn"
//                                                                     onClick={() => handleDelete(index)}
//                                                                 >
//                                                                     <i className="fa fa-trash-alt"/>
//                                                                 </a>
//                                                         </div>
//                                                     </InputBox>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                     <div>
//                                         <InputBox className={"pb-2"}>
//                                             <a className="addBtn  btn-link" onClick={handleAddField}>
//                                                 Add More
//                                             </a>
//                                         </InputBox>
//                                     </div>
//                                 </div>
//                             </Card>

//                             <button type="submit" className="btn btn-primary">
//                                 Submit
//                             </button>
//                             <a
//                                 className=" ms-4 btn btn-danger"
//                                 onClick={() => {
//                                     window.history.back();
//                                 }}>
//                                 Cancel
//                             </a>
//                         </Form>
//                     </div>
//                 </div>
//             </PageHeader>
//         </>
//     );
// };

// export default Form.create()(EditProduct);

// import React, { useEffect, useState } from "react";
// import {
//   Form,
//   notification,
//   InputBox,
//   Card,
// } from "../../components/Elements/appUtils";
// import { FetchCatgory, FetchVariants } from "../variants/actions";
// import { Boolean, vegNonVeg } from "../../components/_utils/_utils";
// import PageHeader from "../../components/Elements/pageHeader";
// import { useDispatch } from "react-redux";
// import { GetEachFormFields } from "../../components/_utils/formUtils";
// import _ from "lodash";
// import { singleProductFxn, updateProductFxn } from "./actions";
// import { category } from "../../components/_utils/appUtils";
// import { getToken, appAxios as axios } from "../../request";
// import { getMainMenuUrl } from "../mainmenu/api";
// import { getMainCategoryUrl } from "../maincategory/api";

// const EditProduct = (props) => {
//   const [formData, setFormData] = useState([
//     { variantId: "", price: "", name: "" },
//   ]);
//   const [allCategory, setAllCategory] = useState([]);
//   const [oldSubCategory, setOldSubCategory] = useState([]);
//   const [productFile, setproductFile] = useState("");
//   const [showDeleteButtons, setShowDeleteButtons] = useState([false]);
//   const [variant, setVariant] = useState([]);
//   const [mainCategoryIndex, setMainCategoryIndex] = useState("");
//   const [categoryIndex, setCategoryIndex] = useState("");
//   const [productId, setproductId] = useState("");
//   const [mainMenus, setMainMenus] = useState([]);
//   const [dynamicMainCategories, setDynamicMainCategories] = useState([]);
//   const [category2,setCategory2]=useState("")

//   const { getFieldValue } = props.form;
//   let dispatch = useDispatch();

//   const handleInputChange = (index, field, value) => {
//     const newData = [...formData];
//     newData[index][field] = value;
//     setFormData(newData);

//     setShowDeleteButtons((prevButtons) =>
//       prevButtons?.map((btn, idx) => (idx === index ? true : btn)),
//     );
//   };

//   const handleDelete = (index) => {
//     const newPayments = [...formData];
//     newPayments.splice(index, 1);

//     setFormData(
//       newPayments.length
//         ? newPayments
//         : [{ variantId: "", price: "", name: "" }],
//     );

//     setShowDeleteButtons((prevButtons) => {
//       const updated = prevButtons?.filter((_, idx) => idx !== index);
//       return updated.length ? updated : [false];
//     });
//   };

//   const handleAddField = () => {
//     let lastData = {};
//     if (formData && formData.length) {
//       lastData = formData[formData.length - 1];
//       if (!lastData.variantId) {
//         notification.warning({ message: "Please Choose Variant" });
//         return;
//       }
//       if (!lastData.price) {
//         notification.warning({ message: "Please Enter Price" });
//         return;
//       }
//     }

//     setFormData([...formData, { variantId: "", price: "", name: "" }]);
//     setShowDeleteButtons([...showDeleteButtons, true]);
//   };

//   const handleFileChange = (e) => {
//     const file = e.files[0];
//     setproductFile(file);
//   };

//   const getMainMenus = async () => {
//     try {
//       const res = await axios.get(getMainMenuUrl(), getToken());
//       if (res.data.success) {
//         setMainMenus(res.data.data || []);
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const loadDynamicMainCategories = async () => {
//     try {
//       const res = await axios.get(getMainCategoryUrl(), getToken());
//       if (res.data.success) {
//         const filtered = (res.data.data || []).filter(
//           (item) => item.deleted !== true,
//         );
//         setDynamicMainCategories(filtered);
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const getVariant = async () => {
//     try {
//       if (!getFieldValue("categoryId")) {
//         setVariant([]);
//         return;
//       }

//       const { data } = await FetchVariants({
//         category: getFieldValue("categoryId"),
//         results: 100,
//         count: 100,
//       });

//       setVariant(data.data || []);
//     } catch (error) {
//       console.error("Error fetching variants:", error);
//     }
//   };

//   const handleState = async () => {
//     let x = await FetchCatgory({
//       results: 500,
//       deleted: { $ne: true },
//     });
//     setAllCategory(x.data || []);
//     setOldSubCategory(x.data || []);
//   };

//   const getSingleproduct = async (id) => {
//     let { data, success } = await dispatch(singleProductFxn(id), getToken());

//     if (success) {
//       const resolvedCategoryId =
//         typeof data.categoryId === "object" ? data.categoryId._id : data.categoryId;

//       setTimeout(() => {
//         props.form.setFieldsValue({
//           name: data.name || "",
//           description: data.description || "",
//           mainMenuId: data.mainMenuId || "",
//           menu: data.mainCategory || data.menu || "",
//           mainCategory: data.mainCategory || "",
//           code: data.code || "",
//           price: data.price || "",
//           categoryId: resolvedCategoryId || "",
//           gst: data.gst,
//           vegNonVeg: data.vegNonVeg || "",
//           coupon: data.coupon,
//         });

//         setMainCategoryIndex(data.mainCategoryIndex || "");
//         setCategoryIndex(data.categoryIndex || "");
//         setFormData(
//           data.variants && data.variants.length
//             ? data.variants
//             : [{ variantId: "", price: "", name: "" }],
//         );
//       }, 300);
//     }
//   };

//   const checkproductId = async () => {
//     let searchParams = new URLSearchParams(window.location.search);
//     const id = searchParams.get("_id");
//     if (id) {
//       setproductId(id);
//       getSingleproduct(id);
//     }
//   };

//   useEffect(() => {
//     handleState();
//     getMainMenus();
//     loadDynamicMainCategories();
//     checkproductId();
//   }, []);

//   useEffect(() => {
//     getVariant();
//   }, [getFieldValue("categoryId")]);

//   useEffect(() => {
//     const selectedMenu = getFieldValue("menu");

//     if (!selectedMenu) {
//       setAllCategory(oldSubCategory);
//       return;
//     }

//     const normalize = (val) =>
//       String(val || "")
//         .trim()
//         .toLowerCase();

//     const subcategory = oldSubCategory.filter((item) => {
//       const selected = normalize(selectedMenu);

//       const staticMatch = normalize(item.menu) === selected;

//       const dynamicMatch =
//         normalize(item.mainCategoryId?.mainCategoryName) === selected ||
//         normalize(item.mainCategoryName) === selected ||
//         normalize(item.mainCategory) === selected;

//       return staticMatch || dynamicMatch;
//     });

//     setAllCategory(subcategory);
//   }, [getFieldValue("menu"), oldSubCategory]);

//   const handleSubmit = (e) => {
//     const { form } = props;
//     e.preventDefault();

//     form.validateFields(async (err, valData) => {
//       if (!err) {
//         const selectedCategory = _.find(allCategory, (item) => {
//           return item._id == valData.categoryId;
//         });

//         if (selectedCategory) {
//           valData.menu =
//             selectedCategory.mainMenuId?.mainMenuName ||
//             valData.menu ||
//             "";

//           valData.mainMenuId =
//             selectedCategory.mainMenuId?._id ||
//             valData.mainMenuId ||
//             "";

//           valData.mainCategory =
//             selectedCategory.mainCategoryId?.mainCategoryName ||
//             valData.mainCategory ||
//             "";
//         }

//         valData._id = productId;
//         valData.variants = formData;
//         valData.mainCategoryIndex = mainCategoryIndex;
//         valData.categoryIndex = categoryIndex;

//         let fd = new FormData();
//         fd.append("obj", JSON.stringify(valData));

//         if (productFile && productFile.name) {
//           fd.append("productFile", productFile);
//         }

//         let x = await dispatch(updateProductFxn(fd));
//         if (x && x.success) {
//           window.history.back();
//         }
//       } else {
//         if (err.name) {
//           notification.warning({
//             message: "Please enter Name",
//           });
//           return;
//         }

//         notification.warning({
//           message: "Fill All Required Fields",
//         });
//       }
//     });
//   };

//   const mergedMainCategories = [
//     ...category.map((item) => ({
//       ...item,
//       source: "static",
//       value: item.name,
//       label: item.name,
//     })),
//     ...dynamicMainCategories.map((item) => ({
//       ...item,
//       source: "dynamic",
//       value: item.mainCategoryName,
//       label: item.mainCategoryName,
//     })),
//   ];

//   let inputTypes = {
//     fields: [
//       {
//         key: "name",
//         label: "Name *",
//         span: "col-md-4",
//       },
//       {
//         key: "description",
//         label: "Description",
//         span: "col-md-4",
//         type: "textarea",
//       },
//       {
//         key: "mainMenuId",
//         label: "Main Menu",
//         span: "col-md-4",
//         type: "select",
//         options: mainMenus,
//         showSearch: true,
//         keyAccessor: (x) => x._id,
//         valueAccessor: (x) => x.mainMenuName.toUpperCase(),
//         onChange: (value) => {
//           props.form.setFieldsValue({
//             mainMenuId: value,
//           });
//         },
//       },
//      {
//              key: "mainCategoryId",
//              label: "Main Category",
//              span: "col-md-4",
//              type: "select",
//              options: mergedMainCategories,
//              keyAccessor: (x) => x._id,
//              valueAccessor: (x) => `${x.label}`,
//              onChange: (selectedOption) => {
//                const findIndex = _.find(mergedMainCategories, (item) => {
//                  return item._id === selectedOption;
//                });

//                if (!findIndex) return;

//                setMainCategoryIndex(findIndex.index || "");
//                props.form.setFieldsValue({
//                  menu: selectedOption,
//                  mainCategoryIndex: findIndex.index || "",
//                  categoryId: "",
//                  mainCategoryId: selectedOption,
//                });

//                category2(oldSubCategory);
//              },
//            },
//       {
//         key: "categoryId",
//         label: "Select Category *",
//         span: "col-md-4",
//         type: "select",
//         options: allCategory,
//         showSearch: true,
//         keyAccessor: (x) => x._id,
//         valueAccessor: (x) => `${x.name}`,
//         onChange: (selectedOption) => {
//           let selectedCategory = _.find(allCategory, (item) => {
//             return item._id == selectedOption;
//           });

//           if (!selectedCategory) return;

//           const resolvedMainCategoryName =
//             selectedCategory.mainCategoryId?.mainCategoryName || "";

//           const resolvedMainMenuId =
//             selectedCategory.mainMenuId?._id ||
//             getFieldValue("mainMenuId") ||
//             "";

//           setMainCategoryIndex(selectedCategory.mainCategoryIndex || "");
//           setCategoryIndex(selectedCategory.index || "");

//           props.form.setFieldsValue({
//             categoryId: selectedOption,
//             mainCategoryIndex: selectedCategory.mainCategoryIndex || "",
//             mainCategory: resolvedMainCategoryName,
//             mainMenuId: resolvedMainMenuId,
//           });
//         },
//       },
//       {
//         key: "code",
//         label: "Code *",
//         span: "col-md-4",
//       },
//       {
//         key: "price",
//         label: "Price *",
//         type: "number",
//         span: "col-md-4",
//         hidden: getFieldValue("type") === "Product",
//       },
//       {
//         key: "gst",
//         label: "GST*",
//         span: "col-md-4",
//         type: "select",
//         options: Boolean,
//         showSearch: true,
//         keyAccessor: (x) => x.value,
//         valueAccessor: (x) => `${x.name}`,
//         onChange: (x) => {
//           props.form.setFieldsValue({
//             gst: x,
//           });
//         },
//       },
//       {
//         key: "coupon",
//         label: "Apply-Discount/Coupon*",
//         span: "col-md-4",
//         type: "select",
//         options: Boolean,
//         showSearch: true,
//         keyAccessor: (x) => x.value,
//         valueAccessor: (x) => `${x.name}`,
//         onChange: (x) => {
//           props.form.setFieldsValue({
//             coupon: x,
//           });
//         },
//       },
//       {
//         key: "vegNonVeg",
//         label: "Veg/Non-Veg/Egg*",
//         span: "col-md-4",
//         type: "select",
//         options: vegNonVeg,
//         showSearch: true,
//         keyAccessor: (x) => x.name,
//         valueAccessor: (x) => `${x.name}`,
//         onChange: (x) => {
//           props.form.setFieldsValue({
//             vegNonVeg: x,
//           });
//         },
//       },
//       {
//         key: "productFile",
//         label: "Product File",
//         required: false,
//         type: "file",
//         fileName: productFile,
//         onChange: ({ target }) => {
//           handleFileChange(target);
//         },
//         span: "col-md-4",
//       },
//     ],
//   };

//   return (
//     <PageHeader title={"Edit Product"}>
//       <div className="card">
//         <div className="card-body">
//           <Form onSubmit={handleSubmit}>
//             <div className="form-elements-wrapper">
//               <div className={"row"}>
//                 {inputTypes.fields.map((item, key) => {
//                   return !item.hidden ? (
//                     <div
//                       className={`${item.span ? item.span : "col-md-6"}`}
//                       key={key}
//                     >
//                       <GetEachFormFields {...props.form} item={item} />
//                     </div>
//                   ) : null;
//                 })}
//               </div>
//             </div>

//             <Card title={"Variants"} size={"small"}>
//               <div>
//                 <div>
//                   {formData?.map((data, index) => (
//                     <div key={index} className={"row"}>
//                       <div className={"col-md-3"}>
//                         <InputBox title={"Variants"}>
//                           <select
//                             className="form-control"
//                             value={data.variantId}
//                             onChange={(e) => {
//                               const value = e.target.value;

//                               if (!value) {
//                                 handleInputChange(index, "variantId", "");
//                                 handleInputChange(index, "name", "");
//                                 return;
//                               }

//                               const parsed = JSON.parse(value);
//                               handleInputChange(index, "variantId", parsed._id);
//                               handleInputChange(index, "name", parsed.name);
//                             }}
//                             required="true"
//                           >
//                             <option value="">
//                               {data.variantId ? ` ${data.name}` : "Select Variant"}
//                             </option>
//                             {variant?.map((item) => (
//                               <option key={item._id} value={JSON.stringify(item)}>
//                                 {item.name}
//                               </option>
//                             ))}
//                           </select>
//                         </InputBox>
//                       </div>

//                       <div className={"col-md-3"}>
//                         <InputBox title={"Price"}>
//                           <input
//                             className={"form-control"}
//                             type="number"
//                             value={data.price}
//                             onChange={(e) =>
//                               handleInputChange(index, "price", e.target.value)
//                             }
//                             placeholder="Amount"
//                           />
//                         </InputBox>
//                       </div>

//                       <div className={"col-md-3"}>
//                         <InputBox className="deleteBtn">
//                           <div key={index} className={"item-flex margin-variant"}>
//                             <a
//                               className="empty_btn"
//                               onClick={() => handleDelete(index)}
//                             >
//                               <i className="fa fa-trash-alt" />
//                             </a>
//                           </div>
//                         </InputBox>
//                       </div>
//                     </div>
//                   ))}
//                 </div>

//                 <div>
//                   <InputBox className={"pb-2"}>
//                     <a className="addBtn btn-link" onClick={handleAddField}>
//                       Add More
//                     </a>
//                   </InputBox>
//                 </div>
//               </div>
//             </Card>

//             <button type="submit" className="btn btn-primary">
//               Submit
//             </button>
//             <a
//               className="ms-4 btn btn-danger"
//               onClick={() => {
//                 window.history.back();
//               }}
//             >
//               Cancel
//             </a>
//           </Form>
//         </div>
//       </div>
//     </PageHeader>
//   );
// };

// export default Form.create()(EditProduct);

import React, {useEffect, useState} from "react";
import {
    Form,
    notification,
    InputBox,
    Card,
} from "../../components/Elements/appUtils";
import {FetchCatgory, FetchVariants} from "../variants/actions";
import {Boolean, vegNonVeg,productTags} from "../../components/_utils/_utils";
import PageHeader from "../../components/Elements/pageHeader";
import {useDispatch} from "react-redux";
import {GetEachFormFields} from "../../components/_utils/formUtils";
import _ from "lodash";
import Modal from "../../components/Elements/Modal";
import {singleProductFxn, updateProductFxn} from "./actions";
import {getToken, appAxios as axios} from "../../request";
import {getMainMenuUrl} from "../mainmenu/api";
import {getMainCategoryUrl} from "../maincategory/api";

const EditProduct = (props) => {
    const [formData, setFormData] = useState([
        {variantId: "", price: "", name: ""},
    ]);
    const [category2, setCategory2] = useState([]);
    const [oldSubCategory, setOldSubCategory] = useState([]);
    const [productFile, setproductFile] = useState("");
    const [variantModalVisible, setVariantModalVisible] = useState(false);
    const [showDeleteButtons, setShowDeleteButtons] = useState([false]);
    const [variant, setVariant] = useState([]);
    const [mainCategoryIndex, setMainCategoryIndex] = useState("");
    const [categoryIndex, setCategoryIndex] = useState("");
    const [productId, setproductId] = useState("");
    const [mainMenus, setMainMenus] = useState([]);
    const [dynamicMainCategories, setDynamicMainCategories] = useState([]);

    const {getFieldValue} = props.form;
    let dispatch = useDispatch();

    const handleInputChange = (index, field, value) => {
        const newData = [...formData];
        newData[index][field] = value;
        setFormData(newData);

        setShowDeleteButtons((prevButtons) =>
            prevButtons?.map((btn, idx) => (idx === index ? true : btn)),
        );
    };

    const handleDelete = (index) => {
        const newPayments = [...formData];
        newPayments.splice(index, 1);

        setFormData(
            newPayments.length
                ? newPayments
                : [{variantId: "", price: "", name: ""}],
        );

        setShowDeleteButtons((prevButtons) => {
            const updated = prevButtons?.filter((_, idx) => idx !== index);
            return updated.length ? updated : [false];
        });
    };

    const handleAddField = () => {
        let lastData = {};
        if (formData && formData.length) {
            lastData = formData[formData.length - 1];
            if (!lastData.variantId) {
                notification.warning({message: "Please Choose Variant"});
                return;
            }
            if (!lastData.price) {
                notification.warning({message: "Please Enter Price"});
                return;
            }
        }

        setFormData([...formData, {variantId: "", price: "", name: ""}]);
        setShowDeleteButtons([...showDeleteButtons, true]);
    };
    const handleVariantModalClose = () => {
        setVariantModalVisible(false);
    };
    const handleVariantModalSave = () => {
        const filledRows = formData.filter(
            (row) => row.variantId || row.price || row.name
        );

        for (let i = 0; i < filledRows.length; i++) {
            if (!filledRows[i].variantId) {
                notification.warning({
                    message: `Please Choose Variant in row ${i + 1}`,
                });
                return;
            }

            if (!filledRows[i].price) {
                notification.warning({
                    message: `Please Enter Price in row ${i + 1}`,
                });
                return;
            }
        }

        setVariantModalVisible(false);
    };
    const handleFileChange = (e) => {
        const file = e.files[0];
        setproductFile(file);
    };
    // };

    const getMainMenus = async () => {
        try {
            const res = await axios.get(getMainMenuUrl(), getToken());
            if (res.data.success) {
                setMainMenus(res.data.data || []);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const loadDynamicMainCategories = async () => {
        try {
            const res = await axios.get(getMainCategoryUrl(), getToken());
            if (res.data.success) {
                const filtered = (res.data.data || []).filter(
                    (item) => item.deleted !== true,
                );
                setDynamicMainCategories(filtered);
            }
        } catch (err) {
            console.log(err);
        }
    };

    // const getVariant = async () => {
    //     try {
    //         if (!getFieldValue("categoryId")) {
    //             setVariant([]);
    //             return;
    //         }
    //
    //         const {data} = await FetchVariants({
    //             category: getFieldValue("categoryId"),
    //             results: 100,
    //             count: 100,
    //         });
    //
    //         setVariant(data.data || []);
    //     } catch (error) {
    //         console.error("Error fetching variants:", error);
    //     }
    // };
    const getVariant = async () => {
        try {
            const { data } = await FetchVariants({
                results: 100,
                count: 100,
            });

            setVariant(data.data || []);
        } catch (error) {
            console.error("Error fetching variants:", error);
        }
    };

    const handleState = async (mainCategoryId) => {
        let x = await FetchCatgory({
            results: 500,
            deleted: {$ne: true},
            mainCategoryId
        });
        setCategory2(x.data || []);
        setOldSubCategory(x.data || []);
    };

    const getSingleproduct = async (id) => {
        let {data, success} = await dispatch(singleProductFxn(id), getToken());

        if (success) {
            const resolvedCategoryId =
                typeof data.categoryId === "object"
                    ? data.categoryId._id
                    : data.categoryId;

            // const resolvedMainMenuId =
            //     data.mainMenuId || data.categoryId?.mainMenuId?._id || "";
            //
            // const resolvedMainCategoryId = data.categoryId?.mainCategoryId?._id || "";

            setTimeout(() => {
                props.form.setFieldsValue({
                    name: data.name || "",
                    description: data.description || "",
                    mainMenuId: data.mainMenuId || undefined,
                    mainCategoryId: data.mainCategoryId || undefined,
                    code: data.code || "",
                    price: data.price || "",
                    // categoryId: data.categoryId || undefined,
                    categoryId: resolvedCategoryId || undefined,
                    // gst: data.gst,
                    gst: typeof data.gst === "boolean" ? data.gst : undefined,
                    vegNonVeg: data.vegNonVeg || "",
                    tag: data.tag || undefined,
                    // coupon: data.coupon,
                });

                setMainCategoryIndex(data.mainCategoryIndex || "");
                setCategoryIndex(data.categoryIndex || "");
                if (data.productFile && (data.productFile.fileName || data.productFile.path)) {
                    setproductFile(data.productFile.fileName || data.productFile.path);
                }
                setFormData(
                    data.variants && data.variants.length
                        ? data.variants
                        : [{variantId: "", price: "", name: ""}],
                );
            }, 300);
        }
    };

    const checkproductId = async () => {
        let searchParams = new URLSearchParams(window.location.search);
        const id = searchParams.get("_id");
        if (id) {
            setproductId(id);
            getSingleproduct(id);
        }
    };

    useEffect(() => {
        handleState();
        getMainMenus();
        loadDynamicMainCategories();
        checkproductId();
    }, []);

    // useEffect(() => {
    //     getVariant();
    // }, [getFieldValue("categoryId")]);
    useEffect(() => {
        getVariant();
    }, []);

    useEffect(() => {
        const selectedMainCategoryId = getFieldValue("mainCategoryId");

        if (!selectedMainCategoryId) {
            setCategory2([]);
            return;
        }

        /*const filteredCategories = category2.filter((item) => {
            return (
                item?.mainCategoryId?._id === selectedMainCategoryId
            );
        });*/
        handleState(selectedMainCategoryId)

        // setCategory2(filteredCategories);
    }, [getFieldValue("mainCategoryId")]);

    const mergedMainCategories = dynamicMainCategories.map((item) => ({
        ...item,
        source: "dynamic",
        value: item._id,
        label: item.mainCategoryName,
    }));

    const filteredMainCategories = mergedMainCategories.filter((item) => {
        const selectedMainMenuId = getFieldValue("mainMenuId");

        if (!selectedMainMenuId) return false;

        return (
            String(item.mainMenuId?._id || item.mainMenuId) ===
            String(selectedMainMenuId)
        );
    });

    const handleSubmit = (e) => {
        const {form} = props;
        e.preventDefault();

        form.validateFields(async (err, valData) => {
            if (!err) {
                const selectedCategory = _.find(category2, (item) => {
                    return item._id == valData.categoryId;
                });

                if (!valData.mainMenuId) {
                    return notification.warning({message: 'Please Choose Main Menu'})
                }
                if (!valData.mainCategoryId) {
                    return notification.warning({message: 'Please Choose Main Category'})
                }
                if (!valData.categoryId) {
                    return notification.warning({message: 'Please Choose Category'})
                }

                if (selectedCategory) {
                    valData.menu =
                        selectedCategory.mainMenuId?.mainMenuName || valData.menu || "";

                    valData.mainMenuId =
                        selectedCategory.mainMenuId?._id || valData.mainMenuId || "";

                    valData.mainCategory =
                        selectedCategory.mainCategoryId?.mainCategoryName ||
                        valData.mainCategory ||
                        "";
                    valData.mainCategoryId =
                        selectedCategory.mainCategoryId?._id ||
                        selectedCategory.mainCategoryId ||
                        valData.mainCategoryId ||
                        "";
                }

                // valData._id = productId;
                // valData.variants = formData;
                // valData.mainCategoryIndex = mainCategoryIndex;
                // valData.categoryIndex = categoryIndex;
                const cleanedVariants = formData.filter(
                    (row) => row.variantId || row.price || row.name
                );

                for (let i = 0; i < cleanedVariants.length; i++) {
                    if (!cleanedVariants[i].variantId) {
                        notification.warning({
                            message: `Please Choose Variant in row ${i + 1}`,
                        });
                        return;
                    }

                    if (!cleanedVariants[i].price) {
                        notification.warning({
                            message: `Please Enter Price in row ${i + 1}`,
                        });
                        return;
                    }
                }

                valData._id = productId;
                valData.variants = cleanedVariants;
                valData.mainCategoryIndex = mainCategoryIndex;
                valData.categoryIndex = categoryIndex;

                let fd = new FormData();
                fd.append("obj", JSON.stringify(valData));

                if (productFile && productFile.name) {
                    fd.append("productFile", productFile);
                }
                // }

                let x = await dispatch(updateProductFxn(fd));
                if (x && x.success) {
                    window.history.back();
                }
            } else {
                if (err.name) {
                    notification.warning({
                        message: "Please enter Name",
                    });
                    return;
                }

                notification.warning({
                    message: "Fill All Required Fields",
                });
            }
        });
    };

    let inputTypes = {
        fields: [
            {
                key: "name",
                label: "Name *",
                span: "col-md-4",
            },
            {
                key: "description",
                label: "Description",
                span: "col-md-4",
                type: "textarea",
            },
            {
                key: "mainMenuId",
                label: "Main Menu",
                span: "col-md-4",
                type: "select",
                options: mainMenus,
                showSearch: true,
                keyAccessor: (x) => x._id,
                valueAccessor: (x) => x.mainMenuName.toUpperCase(),
                onChange: (value) => {
                    props.form.setFieldsValue({
                        mainMenuId: value,
                        mainCategoryId: "",
                        categoryId: "",
                    });
                    setCategory2([]);
                },
            },
            {
                key: "mainCategoryId",
                label: "Main Category",
                span: "col-md-4",
                type: "select",
                options: filteredMainCategories,
                keyAccessor: (x) => x._id,
                valueAccessor: (x) => `${x.label}`,
                onChange: (selectedOption) => {
                    const findIndex = _.find(mergedMainCategories, (item) => {
                        return String(item._id) === String(selectedOption);
                    });

                    if (!findIndex) return;

                    setMainCategoryIndex(findIndex.index || "");
                    props.form.setFieldsValue({
                        mainCategoryIndex: findIndex.index || "",
                        categoryId: "",
                        mainCategoryId: selectedOption,
                    });
                },
            },
            {
                key: "categoryId",
                label: "Select Category *",
                span: "col-md-4",
                type: "select",
                options: category2,
                showSearch: true,
                keyAccessor: (x) => x._id,
                valueAccessor: (x) => `${x.name}`,
                onChange: (selectedOption) => {
                    // let selectedCategory = _.find(category2, (item) => {
                    //   return item._id == selectedOption;
                    // });
                    //
                    // if (!selectedCategory) return;
                    //
                    // const resolvedMainCategoryName =
                    //   selectedCategory.mainCategoryId?.mainCategoryName || "";
                    //
                    // const resolvedMainMenuId =
                    //   selectedCategory.mainMenuId?._id ||
                    //   getFieldValue("mainMenuId") ||
                    //   "";
                    //
                    // setMainCategoryIndex(selectedCategory.mainCategoryIndex || "");
                    // setCategoryIndex(selectedCategory.index || "");

                    props.form.setFieldsValue({
                        categoryId: selectedOption,
                        // mainCategoryIndex: selectedCategory.mainCategoryIndex || "",
                        // mainCategory: resolvedMainCategoryName,
                        // mainMenuId: resolvedMainMenuId,
                    });
                },
            },
            {
                key: "code",
                label: "Code *",
                span: "col-md-4",
            },
            {
                key: "price",
                label: "Price *",
                type: "number",
                span: "col-md-4",
                hidden: getFieldValue("type") === "Product",
            },
            {
                key: "gst",
                label: "GST*",
                span: "col-md-4",
                type: "select",
                options: Boolean,
                showSearch: true,
                keyAccessor: (x) => x.value,
                valueAccessor: (x) => `${x.name}`,
                onChange: (x) => {
                    props.form.setFieldsValue({
                        gst: x,
                    });
                },
            },
            // {
            //     key: "coupon",
            //     label: "Apply-Discount/Coupon*",
            //     span: "col-md-4",
            //     type: "select",
            //     options: Boolean,
            //     showSearch: true,
            //     keyAccessor: (x) => x.value,
            //     valueAccessor: (x) => `${x.name}`,
            //     onChange: (x) => {
            //         props.form.setFieldsValue({
            //             coupon: x,
            //         });
            //     },
            // },
            {
                key: "vegNonVeg",
                label: "Veg/Non-Veg/Egg*",
                span: "col-md-4",
                type: "select",
                options: vegNonVeg,
                showSearch: true,
                keyAccessor: (x) => x.name,
                valueAccessor: (x) => `${x.name}`,
                onChange: (x) => {
                    props.form.setFieldsValue({
                        vegNonVeg: x,
                    });
                },
            },
            // {
            //     key: "tag",
            //     label: "Product Tag",
            //     span: "col-md-4",
            //     type: "select",
            //     options: productTags,
            //     showSearch: true,
            //     keyAccessor: (x) => x.name,
            //     valueAccessor: (x) => `${x.name}`,
            //     onChange: (x) => {
            //         props.form.setFieldsValue({
            //             tag: x,
            //         });
            //     },
            // },
            {
                key: "tag",
                label: "Product Tag",
                span: "col-md-4",
                type: "select",
                options: [
                    { name: "None (Remove Tag)", val: "" },
                    ...productTags.map(t => ({ name: t.name, val: t.name }))
                ],
                showSearch: true,
                keyAccessor: (x) => x.val,
                valueAccessor: (x) => x.name,
                onChange: (x) => {
                    props.form.setFieldsValue({
                        tag: x,
                    });
                },
            },
            {
                key: "productFile",
                label: "Product File",
                required: false,
                type: "file",
                fileName: productFile,
                onChange: ({target}) => {
                    handleFileChange(target);
                },
                span: "col-md-4",
            },
            /*
            //     required: false,
            //     type: "file",
            //     fileName: productFile,
            //     onChange: ({target}) => {
            //         handleFileChange(target);
            //     },
            //     span: "col-md-4", */
            // },
        ],
    };

    return (
        <PageHeader title={"Edit Product"}>
            <div className="card">
                <div className="card-body">
                    <Form onSubmit={handleSubmit}>
                        <div className="form-elements-wrapper">
                            <div className={"row"}>
                                {inputTypes.fields.map((item, key) => {
                                    return !item.hidden ? (
                                        <div
                                            className={`${item.span ? item.span : "col-md-6"}`}
                                            key={key}
                                        >
                                            <GetEachFormFields {...props.form} item={item}/>
                                        </div>
                                    ) : null;
                                })}
                            </div>
                        </div>

                        {/*<Card title={"Variants"} size={"small"}>*/}
                        {/*    <div>*/}
                        {/*        <div>*/}
                        {/*            {formData?.map((data, index) => (*/}
                        {/*                <div key={index} className={"row"}>*/}
                        {/*                    <div className={"col-md-3"}>*/}
                        {/*                        <InputBox title={"Variants"}>*/}
                        {/*                            <select*/}
                        {/*                                className="form-control"*/}
                        {/*                                value={data.variantId}*/}
                        {/*                                onChange={(e) => {*/}
                        {/*                                    const value = e.target.value;*/}

                        {/*                                    if (!value) {*/}
                        {/*                                        handleInputChange(index, "variantId", "");*/}
                        {/*                                        handleInputChange(index, "name", "");*/}
                        {/*                                        return;*/}
                        {/*                                    }*/}

                        {/*                                    const parsed = JSON.parse(value);*/}
                        {/*                                    handleInputChange(index, "variantId", parsed._id);*/}
                        {/*                                    handleInputChange(index, "name", parsed.name);*/}
                        {/*                                }}*/}
                        {/*                                required="true"*/}
                        {/*                            >*/}
                        {/*                                <option value="">*/}
                        {/*                                    {data.variantId*/}
                        {/*                                        ? ` ${data.name}`*/}
                        {/*                                        : "Select Variant"}*/}
                        {/*                                </option>*/}
                        {/*                                {variant?.map((item) => (*/}
                        {/*                                    <option*/}
                        {/*                                        key={item._id}*/}
                        {/*                                        value={JSON.stringify(item)}*/}
                        {/*                                    >*/}
                        {/*                                        {item.name}*/}
                        {/*                                    </option>*/}
                        {/*                                ))}*/}
                        {/*                            </select>*/}
                        {/*                        </InputBox>*/}
                        {/*                    </div>*/}

                        {/*                    <div className={"col-md-3"}>*/}
                        {/*                        <InputBox title={"Price"}>*/}
                        {/*                            <input*/}
                        {/*                                className={"form-control"}*/}
                        {/*                                type="number"*/}
                        {/*                                value={data.price}*/}
                        {/*                                onChange={(e) =>*/}
                        {/*                                    handleInputChange(index, "price", e.target.value)*/}
                        {/*                                }*/}
                        {/*                                placeholder="Amount"*/}
                        {/*                            />*/}
                        {/*                        </InputBox>*/}
                        {/*                    </div>*/}

                        {/*                    <div className={"col-md-3"}>*/}
                        {/*                        <InputBox className="deleteBtn">*/}
                        {/*                            <div*/}
                        {/*                                key={index}*/}
                        {/*                                className={"item-flex margin-variant"}*/}
                        {/*                            >*/}
                        {/*                                <a*/}
                        {/*                                    className="empty_btn"*/}
                        {/*                                    onClick={() => handleDelete(index)}*/}
                        {/*                                >*/}
                        {/*                                    <i className="fa fa-trash-alt"/>*/}
                        {/*                                </a>*/}
                        {/*                            </div>*/}
                        {/*                        </InputBox>*/}
                        {/*                    </div>*/}
                        {/*                </div>*/}
                        {/*            ))}*/}
                        {/*        </div>*/}

                        {/*        <div>*/}
                        {/*            <InputBox className={"pb-2"}>*/}
                        {/*                <a className="addBtn btn-link" onClick={handleAddField}>*/}
                        {/*                    Add More*/}
                        {/*                </a>*/}
                        {/*            </InputBox>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</Card>*/}
                        <Modal
                            title="Edit Variants"
                            visible={variantModalVisible}
                            onClose={handleVariantModalClose}
                            width={900}
                            className="product-variant-modal"
                        >
                            <div>
                                {formData?.map((data, index) => (
                                    <div key={index} className={"row"}>
                                        <div className={"col-md-5"}>
                                            <InputBox title={"Variants"}>
                                                <select
                                                    className="form-control"
                                                    value={data.variantId}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        if (!value) {
                                                            handleInputChange(index, "variantId", "");
                                                            handleInputChange(index, "name", "");
                                                            return;
                                                        }

                                                        const parsed = JSON.parse(value);
                                                        handleInputChange(index, "variantId", parsed._id);
                                                        handleInputChange(index, "name", parsed.name);
                                                    }}
                                                >
                                                    <option value="">
                                                        {data.variantId ? ` ${data.name}` : "Select Variant"}
                                                    </option>

                                                    {variant?.map((item) => (
                                                        <option key={item._id} value={JSON.stringify(item)}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </InputBox>
                                        </div>

                                        <div className={"col-md-4"}>
                                            <InputBox title={"Price"}>
                                                <input
                                                    className={"form-control"}
                                                    type="number"
                                                    value={data.price}
                                                    onChange={(e) =>
                                                        handleInputChange(index, "price", e.target.value)
                                                    }
                                                    placeholder="Amount"
                                                />
                                            </InputBox>
                                        </div>

                                        <div className={"col-md-3"}>
                                            <InputBox className="deleteBtn">
                                                <div className={"item-flex margin-variant"}>
                                                    <a
                                                        className="empty_btn"
                                                        onClick={() => handleDelete(index)}
                                                    >
                                                        <i className="fa fa-trash-alt" />
                                                    </a>
                                                </div>
                                            </InputBox>
                                        </div>
                                    </div>
                                ))}

                                <div>
                                    <InputBox className={"pb-2"}>
                                        <a className="addBtn btn-link" onClick={handleAddField}>
                                            Add More
                                        </a>
                                    </InputBox>
                                </div>

                                <div className="mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleVariantModalSave}
                                    >
                                        Save Variants
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-danger ms-2"
                                        onClick={handleVariantModalClose}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </Modal>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setVariantModalVisible(true)}
                        >
                            Add Variants
                        </button>

                        <button type="submit" className="btn btn-primary ms-2">
                            Submit
                        </button>

                        <a
                            className="ms-2 btn btn-danger"
                            onClick={() => {
                                window.history.back();
                            }}
                        >
                            Cancel
                        </a>
                    </Form>
                </div>
            </div>
        </PageHeader>
    );
};

export default Form.create()(EditProduct);
